import { State } from '../reducers/rootReducer'

const filtersAreVisibleSelector = (state: State): boolean => (
    state.carlineSelection.filtersAreVisible
)

export default filtersAreVisibleSelector
